import { render, staticRenderFns } from "./boList.vue?vue&type=template&id=156625de&scoped=true&"
import script from "./boList.vue?vue&type=script&lang=js&"
export * from "./boList.vue?vue&type=script&lang=js&"
import style0 from "./boList.vue?vue&type=style&index=0&id=156625de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156625de",
  null
  
)

export default component.exports